(function () {
	class Lightbox {
		constructor(params) {
			this.lightbox = params.lightbox;
			this.images = document.querySelectorAll('.gallery__item');
			this.imageContainer = this.lightbox.querySelector('.gallery-lightbox__image-img');
			this.imageLoader = this.lightbox.querySelector('.gallery-lightbox__image-loader');
			this.close = this.lightbox.querySelector('.gallery-lightbox__close');
			this.next = this.lightbox.querySelector('.gallery-lightbox__next');
			this.prev = this.lightbox.querySelector('.gallery-lightbox__prev');
			this.current = this.lightbox.querySelector('.gallery-lightbox__current');
			this.total = this.lightbox.querySelector('.gallery-lightbox__total');
			this.lightboxAnimation = null;
			this.activeIndex = null;
		}

		init() {
			this.lightboxAnimation = this.createLightboxAnimation();
			// this.toggleLightbox();
			this.bindListeners();
			this.togglePaginationStates();
		}

		bindListeners() {
			const { next, prev, close, images, total } = this;

			// Add to setup function
			total.innerText = images.length;

			close.addEventListener('click', e => {
				this.toggleLightbox();
			});

			images.forEach((image, index) => {
				image.addEventListener('click', e => {
					this.toggleLightbox();
					this.toggleImage(index);
					this.togglePaginationStates();
				});
			});
			next.addEventListener('click', e => {
				if (this.activeIndex === null || this.activeIndex === images.length - 1) return;
				this.togglePagination((this.activeIndex += 1));
			});
			prev.addEventListener('click', e => {
				if (this.activeIndex === null || this.activeIndex === 0) return;
				this.togglePagination((this.activeIndex -= 1));
			});
		}

		togglePaginationStates() {
			const { next, prev, activeIndex, images, current } = this;
			current.innerText = activeIndex + 1;
			if (this.activeIndex === images.length - 1) {
				next.classList.add('gallery-lightbox--disabled');
			} else if (this.activeIndex === 0 || this.activeIndex === null) {
				prev.classList.add('gallery-lightbox--disabled');
			} else {
				next.classList.remove('gallery-lightbox--disabled');
				prev.classList.remove('gallery-lightbox--disabled');
			}
		}

		togglePagination(val) {
			const { images, activeIndex, next, prev, current, total } = this;

			this.togglePaginationStates();
			this.toggleImage(val);
		}

		toggleImage(index) {
			const { images, imageContainer, lightbox, imageLoader } = this;

			const thumbnail = images[index];
			const url = thumbnail.dataset.url;
			const caption = thumbnail.dataset.caption;
			let image = new Image();
			image.src = url;
			imageLoader.classList.add('gallery-lightbox__image-loader--loading');
			imageLoader.classList.remove('gallery-lightbox__image-loader--loaded');
			image.onload = function () {
				setTimeout(() => {
					imageLoader.classList.remove('gallery-lightbox__image-loader--loading');
					imageLoader.classList.add('gallery-lightbox__image-loader--loaded');
					imageContainer.innerHTML = '';
					imageContainer.append(image);
					lightbox.querySelector('.gallery-lightbox__caption').innerText = caption;
				}, 1000);
			};
			this.activeIndex = index;
		}

		toggleLightbox() {
			const { lightboxAnimation } = this;
			lightboxAnimation.reversed() ? lightboxAnimation.play() : lightboxAnimation.reverse();
		}

		createLightboxAnimation() {
			const { lightbox, imageLoader } = this;
			const tl = gsap.timeline({ reversed: true });
			tl.from(lightbox, {
				duration: 0.3,
				// delay: 1,
				autoAlpha: 0,
				onComplete: () => {
					if (!tl.reversed()) {
						lightbox.classList.add('gallery-lightbox--toggled');
					}
				},
				onReverseComplete: () => {
					if (tl.reversed()) {
						lightbox.classList.remove('gallery-lightbox--toggled');
						imageLoader.classList.remove('gallery-lightbox__image-loader--loading');
						imageLoader.classList.remove('gallery-lightbox__image-loader--loaded');
					}
				},
			});
			return tl;
		}
	}

	const lightboxes = document.querySelectorAll('.gallery-lightbox');
	if (lightboxes === null || lightboxes === undefined) return;

	lightboxes.forEach(lightbox => {
		new Lightbox({ lightbox }).init();
	});
})();
